import React from "react";
import Box from "@mui/material/Box";
import {DataGrid} from "@mui/x-data-grid";
import type {GridCallbackDetails, GridPaginationModel} from "@mui/x-data-grid";
import type {
  HeaderRecordProps,
  RecordsDataProps,
} from "components/Dialogs/IndividualPaymentLimitsReportColumns";
import {reportDialogStyle} from "components/Dialogs/reportDialogStyle";
import {CPSConstants} from "commonUtils/enumerations";
import {DATA_GRID_SORT_ORDER} from "config/constants";

interface Props {
  datagridheadermedia: number;
  columns: HeaderRecordProps[] | any[];
  records: RecordsDataProps[];
  totalrecordscount: number;
  hideFooter: boolean;
  loader: boolean;
  paginationModel: any;
  onSortModelChange: any;
  onPaginationModelChange:
    | ((model: GridPaginationModel, details: GridCallbackDetails<any>) => void)
    | undefined;
}

const IndividualPaymentReportGrid: React.FC<Props> = ({
  datagridheadermedia,
  columns,
  records,
  totalrecordscount,
  hideFooter,
  loader,
  paginationModel,
  onSortModelChange,
  onPaginationModelChange,
}) => {
  const rowsPerPageOptions = [
    {value: 10, label: "10"},
    {value: 25, label: "25"},
    {value: 50, label: "50"},
    {value: 100, label: "All"}, // The DataGrid (MIT license) is limited to pages of up to 100 rows.
  ];

  return (
    <DataGrid
      className="individual-payment-dialog-container"
      sx={reportDialogStyle.dataGridStyle}
      columnHeaderHeight={datagridheadermedia}
      rowHeight={CPSConstants.GRID_ROW_HEIGHT as number}
      sortingOrder={DATA_GRID_SORT_ORDER}
      rows={records}
      rowCount={totalrecordscount ?? 100}
      columns={columns.map((column, index: number) => ({
        ...column,
        headerName: (
          <Box
            key={index}
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              lineHeight: "1.2",
              paddingTop: "0.313rem",
              paddingBottom: "0.313rem",
            }}>
            {column?.headerName}
          </Box>
        ),
      }))}
      disableColumnSelector
      hideFooter={hideFooter}
      loading={loader}
      initialState={{
        pagination: {
          paginationModel: {
            page: paginationModel?.page,
            pageSize: paginationModel?.pageSize,
          },
        },
      }}
      pageSizeOptions={rowsPerPageOptions}
      paginationMode="server" // This props is very important for Server-side pagination
      onSortModelChange={onSortModelChange}
      onPaginationModelChange={onPaginationModelChange}
      slotProps={{pagination: {labelRowsPerPage: "Rows per Page"}}}
    />
  );
};

export default IndividualPaymentReportGrid;
